import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDateTime } from "../lib/api";
import { ResearchBadge } from "../components/Badges";

export default function Jobs() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    const load = () => api.get("/jobs").then((r) => setJobs(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs font-semibold uppercase tracking-wider text-orange-600">Server jobs</div>
        <h1 className="mt-1 text-3xl font-extrabold tracking-tight">Research jobs</h1>
        <p className="mt-1 text-sm text-slate-500">Jobs run on the server and continue if you close or refresh the page.</p>
      </div>
      <div className="space-y-2">
        {jobs.map((j) => {
          const done = j.stages.filter((s) => ["done", "skipped"].includes(s.status)).length;
          return (
            <Link key={j.id} to={`/leads/${j.location_id}`} className="flex flex-wrap items-center justify-between gap-3 rounded-lg border bg-white p-4 shadow-sm hover:border-orange-300" data-testid={`job-row-${j.id}`}>
              <div>
                <div className="font-semibold">{j.location_name}</div>
                <div className="text-xs text-slate-500">Started {fmtDateTime(j.created_at)} · {done}/{j.stages.length} stages · {j.errors.length} issue(s)</div>
              </div>
              <div className="flex items-center gap-3">
                <div className="hidden h-1.5 w-40 overflow-hidden rounded-full bg-slate-100 sm:block"><div className="h-full bg-orange-500 transition-all" style={{ width: `${(done / j.stages.length) * 100}%` }} /></div>
                <ResearchBadge status={j.status} />
              </div>
            </Link>
          );
        })}
        {jobs.length === 0 && <div className="rounded-lg border border-dashed p-10 text-center text-sm text-slate-500" data-testid="jobs-empty">No research jobs yet. Start from Find Restaurants.</div>}
      </div>
    </div>
  );
}
